import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import {
  RadioGroup, RadioGroupItem
} from "@/components/ui/radio-group"
import {
  Tabs, TabsContent, TabsList, TabsTrigger
} from "@/components/ui/tabs"
import {
  cn
} from "@/lib/utils"
import clsx from "clsx"
import {
  ReactNode,
  useMemo, useState
} from "react"
import {
  useFormContext
} from "react-hook-form"
import {
  ProductRoot
} from "../types/product"

export const ChangeStyle = ({
  product 
}: { product: ProductRoot }) => {


  const change_style = product?.change_style


  const form = useFormContext()
  const {
    Size 
  } = form.watch() || {}
  const isCustomizedSize = Size?.label === "customized_size"
  const [expanded, setExpanded] = useState(true)

  const hasBackOption = useMemo(() => {
    if (!change_style) {
      return false
    }

    return change_style.includes("Back Detail")
  }, [change_style])

  const hasLengthOption = useMemo(() => {
    if (!change_style) {
      return false
    }

    return change_style.includes("Length")
  }, [change_style])

  const hasPocketsOption = useMemo(() => {
    if (!change_style) {
      return false
    }

    return change_style.includes("Pockets")
  }, [change_style])

  type tabsType = {
    value: string
    name: string
    label: string
    options: {
      value: string
      label: string
      bgPosition: string
      selectedBgPosition: string
    }[]
  }[]

  const tabs = useMemo(
    () => [
      hasLengthOption && {
        value: "length",
        name: "length",
        label: "Length",
        options: [
          {
            value: "kneelength",
            label: "Knee Length",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='40'
                height='80'
                fill='none'
                viewBox='0 0 40 80'
              >
                <g clipPath='url(#clip0_12958_7483)'>
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M31.601 31.573c-.241-1.208-.543-1.45-.725-2.174-.12-.544-.12-1.872-.18-2.476-.242-2.294-.303-3.02-1.631-6.944-.544-1.69-.181-3.442.423-6.34.845-4.166 2.173-9.299.604-10.869-.906-.906-5.374-1.268-6.34-1.57-1.148-.362-.967-3.2-.967-3.2h-2.959s0 2.596-1.268 3.08c-1.328.483-3.924 0-5.494 1.207-1.691 1.268-1.932 3.563-1.812 7.608.181 4.952.362 9.42.362 9.42s-.482 1.57-1.932 4.71-2.777 5.857-3.019 6.944c-.12.543-.302 1.57.181 2.717.544 1.328 2.174 2.174 1.933 1.63-.604-1.389-1.208-3.14-.725-3.381 0 0 .785 1.872 1.328 1.69.242-.06-.18-.603-.18-1.388.06-1.57-.725-1.57 0-2.96 1.388-2.777 3.441-4.407 3.924-5.554s2.295-2.959 2.476-4.529c.12-1.147 2.777-5.857 4.287-8.453l2.415 22.1 4.891-.423 2.717.18c.604.544-.12.424.363.726.966.603 1.63-.121 1.328-1.751M13.911 47.031s-.12 5.193 2.234 10.265c2.476 5.374 4.59 11.533 4.227 13.888-.423 2.959-.12 6.22 1.932 3.683 1.329-1.63.181-5.253.181-6.28 0-1.086-1.086-7.547-2.294-13.283-1.208-5.737-.483-8.273-.483-8.273z'
                  />
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M19.102 48.844s.604 4.408.543 5.253c-.06.846-.845 3.442-.966 5.556-.18 2.113-.604 10.325-.543 11.714.12 3.381-1.329 5.132-1.812 6.702-.543 1.51.544 2.657 2.295 1.389s1.449-3.02 1.389-4.529c-.06-1.51 3.502-11.533 4.045-14.491.544-2.96.121-4.71-.12-5.918-.242-1.208 1.026-5.978 1.207-6.944.181-.906.362-4.287.362-4.287l-6.642.242z'
                  />
                  <path
                    fill={isSelected ? "#BE9983" : "#F8F3EF"}
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M12.521 8.926s-.664 1.872.06 3.623c.665 1.57 2.356 4.83 1.873 7.307-.484 2.475-2.537 3.985-3.805 9.48C9.381 34.83 8.355 42.378 6 46.363c0 0 5.797 4.046 16.666 3.502 10.868-.543 11.593-5.434 11.593-5.434s-1.872-6.642-3.26-12.257c-1.269-5.193-2.778-8.937-5.194-12.5 0 0-.362-2.173.604-3.562 1.51-2.295 2.536-4.951 1.751-8.816-.543-2.536.121-5.374.121-5.374l-2.113-.483s-4.59 3.563-6.039 7.246c0 0-2.173-3.08-3.2-7.427l-1.992.12s-1.51 3.684-2.416 7.548'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M19.828 8.203s3.804 6.099 6.22 8.635z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M19.828 8.203s3.804 6.099 6.22 8.635'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M14.395 17.445s7.97.604 11.472 0z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M14.395 17.445s7.97.604 11.472 0'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M14.574 19.195s4.046.483 11.11.181z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M14.574 19.195s4.046.483 11.11.181'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_12958_7483'>
                    <path fill='#fff' d='M0 0h40v80H0z' />
                  </clipPath>
                </defs>
              </svg>
            }
          },
          {
            value: "tealength",
            label: "Tea Length",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='40'
                height='80'
                fill='none'
                viewBox='0 0 40 80'
              >
                <g clipPath='url(#clip0_10923_24677)'>
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M31.482 31.573c-.241-1.208-.543-1.45-.724-2.174-.121-.544-.121-1.872-.182-2.476-.241-2.294-.302-3.02-1.63-6.944-.543-1.69-.181-3.442.423-6.34.845-4.166 2.173-9.299.604-10.869-.906-.906-5.374-1.268-6.34-1.57-1.148-.362-.967-3.2-.967-3.2h-2.898s0 2.596-1.268 3.08c-1.328.483-3.925 0-5.495 1.207-1.69 1.329-1.993 3.563-1.811 7.669.18 4.951.362 9.42.362 9.42s-.483 1.57-1.932 4.71c-1.45 3.139-2.778 5.856-3.02 6.943-.12.544-.301 1.57.182 2.717.543 1.329 2.174 2.174 1.932 1.63-.604-1.388-1.208-3.14-.725-3.38 0 0 .785 1.871 1.329 1.69.241-.06-.181-.604-.181-1.389.06-1.57-.725-1.57 0-2.959 1.388-2.777 3.441-4.408 3.925-5.555.483-1.147 2.294-2.959 2.475-4.529.12-1.147 2.778-5.857 4.287-8.453l2.416 22.1 4.89-.423 2.718.181c.604.544-.121.423.362.725.966.543 1.63-.181 1.268-1.811M13.849 47.031s-.121 5.193 2.234 10.265c2.476 5.374 4.589 11.533 4.227 13.888-.423 2.959-.121 6.22 1.932 3.683 1.328-1.63.181-5.253.181-6.28 0-1.086-1.087-7.547-2.295-13.283-1.207-5.737-.362-8.212-.362-8.212H13.85z'
                  />
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M19.043 48.844s.604 4.408.544 5.253c-.06.846-.846 3.442-.966 5.556-.181 2.113-.604 10.325-.544 11.714.12 3.381-1.328 5.132-1.811 6.702-.544 1.51.543 2.657 2.294 1.389s1.45-3.02 1.389-4.529c-.06-1.51 3.502-11.533 4.046-14.491.543-2.96.12-4.71-.121-5.918-.242-1.208 1.026-5.978 1.207-6.944.182-.906.363-4.287.363-4.287l-6.642.242z'
                  />
                  <path
                    fill={isSelected ? "#BE9983" : "#F8F3EF"}
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M12.521 8.932s-.664 2.536.06 4.227c.665 1.57 2.356 4.166 1.873 6.642-.484 2.476-2.537 3.985-3.805 9.48S8.295 52.468 6 56.453c0 0 5.797 4.045 16.666 3.502s12.076-5.676 12.076-5.676-2.113-12.137-4.227-21.677c-1.147-5.253-2.294-9.42-4.71-12.982 0 0-.362-2.174.604-3.563 1.51-2.294 2.536-4.951 1.751-8.816-.604-2.475.06-5.374.06-5.374l-2.113-.483S21.518 4.947 20.07 8.63c0 0-2.174-3.08-3.2-7.427l-1.932.181s-1.51 3.684-2.416 7.548'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M19.766 8.203s3.804 6.099 6.219 8.635z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M19.766 8.203s3.804 6.099 6.219 8.635'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M14.332 17.445s7.97.604 11.473 0z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M14.332 17.445s7.97.604 11.473 0'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M14.512 19.195s4.045.483 11.11.181z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M14.512 19.195s4.045.483 11.11.181'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_10923_24677'>
                    <path fill='#fff' d='M0 0h40v80H0z' />
                  </clipPath>
                </defs>
              </svg>
            }
          },
          {
            value: "anklelength",
            label: "Ankle Length",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='40'
                height='80'
                fill='none'
                viewBox='0 0 40 80'
              >
                <g clipPath='url(#clip0_10923_24729)'>
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M30.601 31.573c-.241-1.208-.543-1.45-.725-2.174-.12-.544-.12-1.872-.18-2.476-.242-2.294-.303-3.02-1.631-6.944-.544-1.69-.181-3.442.423-6.34.845-4.166 2.173-9.299.604-10.869-.906-.906-5.374-1.268-6.34-1.57-1.148-.362-.967-3.2-.967-3.2h-2.959s0 2.596-1.268 3.08c-1.328.483-3.924 0-5.494 1.207-1.691 1.329-1.993 3.563-1.812 7.669.181 4.951.362 9.42.362 9.42s-.482 1.57-1.932 4.71-2.777 5.856-3.019 6.943c-.12.544-.302 1.57.181 2.717.544 1.329 2.174 2.174 1.933 1.63-.604-1.388-1.208-3.14-.725-3.38 0 0 .785 1.871 1.328 1.69.242-.06-.18-.604-.18-1.389.06-1.57-.725-1.57 0-2.959 1.388-2.777 3.441-4.408 3.924-5.555s2.295-2.959 2.476-4.529c.12-1.147 2.777-5.857 4.287-8.453l2.415 22.1 4.891-.423 2.717.181c.604.544-.12.423.363.725.966.543 1.63-.181 1.328-1.811M12.849 47.031s-.121 5.193 2.234 10.265c2.475 5.374 4.589 11.533 4.227 13.888-.423 2.959-.121 6.22 1.932 3.683 1.328-1.63.181-5.253.181-6.28 0-1.086-1.087-7.547-2.295-13.283-1.207-5.737-.362-8.212-.362-8.212H12.85z'
                  />
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M18.102 48.844s.604 4.408.543 5.253c-.06.846-.845 3.442-.966 5.556-.18 2.113-.604 10.325-.543 11.714.12 3.381-1.329 5.132-1.812 6.702-.543 1.51.544 2.657 2.295 1.389s1.449-3.02 1.389-4.529c-.06-1.51 3.502-11.533 4.045-14.491.544-2.96.121-4.71-.12-5.918-.242-1.208 1.026-5.978 1.207-6.944.181-.906.362-4.287.362-4.287l-6.642.242z'
                  />
                  <path
                    fill={isSelected ? "#BE9983" : "#F8F3EF"}
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M11.521 8.926s-.664 2.536.06 4.227c.665 1.57 2.356 4.167 1.873 6.642-.484 2.476-2.537 3.985-3.805 9.48S7.295 60.553 5 64.6c0 0 5.797 4.045 16.666 3.502s12.86-6.4 12.86-6.4-2.656-14.13-5.071-29.044c-.846-5.314-2.295-9.42-4.71-12.983 0 0-.362-2.173.604-3.562 1.51-2.295 2.536-4.951 1.75-8.816-.543-2.536.122-5.374.122-5.374l-2.114-.483s-4.589 3.563-6.038 7.246c0 0-2.174-3.08-3.2-7.427l-1.993.12c.06 0-1.449 3.684-2.355 7.548'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M18.828 8.203s3.804 6.099 6.22 8.635z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M18.828 8.203s3.804 6.099 6.22 8.635'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M13.395 17.445s7.97.604 11.472 0z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M13.395 17.445s7.97.604 11.472 0'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M13.574 19.195s4.046.483 11.11.181z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M13.574 19.195s4.046.483 11.11.181'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_10923_24729'>
                    <path fill='#fff' d='M0 0h40v80H0z' />
                  </clipPath>
                </defs>
              </svg>
            }
          },
          {
            value: "floorlength",
            label: "Floor Length",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='40'
                height='80'
                fill='none'
                viewBox='0 0 40 80'
              >
                <g clipPath='url(#clip0_10923_24781)'>
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M30.773 31.568c-.241-1.208-.543-1.45-.724-2.174-.121-.543-.121-1.871-.181-2.475-.242-2.294-.302-3.019-1.63-6.943-.544-1.69-.182-3.441.422-6.34.845-4.165 2.174-9.297.604-10.866-.906-.906-5.373-1.268-6.34-1.57C21.779.838 21.96-2 21.96-2H19s0 2.596-1.267 3.079c-1.329.483-3.925 0-5.494 1.208-1.69 1.328-1.993 3.562-1.812 7.667.181 4.95.363 9.418.363 9.418s-.483 1.57-1.932 4.71c-1.45 3.139-2.778 5.856-3.019 6.942-.12.544-.302 1.57.181 2.717.543 1.328 2.174 2.174 1.932 1.63-.604-1.388-1.207-3.14-.724-3.38 0 0 .784 1.87 1.328 1.69.241-.06-.181-.604-.181-1.389.06-1.57-.725-1.57 0-2.958 1.388-2.777 3.441-4.407 3.924-5.555s2.294-2.958 2.475-4.527c.121-1.148 2.777-5.857 4.287-8.453l2.415 22.097 4.89-.423 2.717.181c.604.544-.121.423.362.725.966.543 1.63-.181 1.328-1.811M13.083 47.023s-.12 5.193 2.234 10.264c2.475 5.373 4.588 11.531 4.226 13.886-.423 2.958-.12 6.218 1.932 3.683 1.328-1.63.181-5.253.181-6.28 0-1.086-1.087-7.546-2.294-13.281S19 47.084 19 47.084h-5.917z'
                  />
                  <path
                    fill='#fff'
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M18.275 48.836s.604 4.407.544 5.252-.845 3.441-.966 5.554c-.181 2.114-.604 10.324-.544 11.713.121 3.38-1.328 5.132-1.81 6.701-.484 1.57.543 2.657 2.294 1.389s1.448-3.019 1.388-4.528c-.06-1.51 3.502-11.531 4.045-14.49s.12-4.709-.12-5.916c-.242-1.208 1.026-5.977 1.207-6.943.18-.906.362-4.287.362-4.287l-6.641.242z'
                  />
                  <path
                    fill={isSelected ? "#BE9983" : "#F8F3EF"}
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M11.694 8.925s-.664 2.536.06 4.226c.664 1.57 2.355 4.166 1.872 6.642s-2.536 3.984-3.804 9.478-4.166 35.5-6.822 45.1c0 0 7.909 4.165 18.776 3.622s15.214-6.098 15.214-6.098-2.354-9.78-7.365-39.243c-.906-5.313-2.294-9.418-4.71-12.98 0 0-.362-2.174.604-3.562 1.51-2.294 2.536-4.95 1.751-8.815-.543-2.536.12-5.373.12-5.373l-2.112-.483S20.69 5 19.24 8.684c0 0-2.174-3.08-3.2-7.426l-1.993.12c.06 0-1.449 3.683-2.354 7.547'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M19 8.203s3.803 6.098 6.218 8.634z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M19 8.203s3.803 6.098 6.218 8.634'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M13.566 17.438s7.97.603 11.471 0z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M13.566 17.438s7.97.603 11.471 0'
                  />
                  <path fill={isSelected ? "#BE9983" : "#F8F3EF"} d='M13.746 19.188s4.045.483 11.109.18z' />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.66'
                    d='M13.746 19.188s4.045.483 11.109.18'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_10923_24781'>
                    <path fill='#fff' d='M0 0h40v80H0z' />
                  </clipPath>
                </defs>
              </svg>
            }
          },
        ],
      },
      hasPocketsOption && {
        value: "pockets",
        name: "pocket",
        label: "Pockets",
        options: [
          {
            value: "addpockets",
            label: "Add Pockets",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='64'
                height='80'
                fill='none'
                viewBox='0 0 64 80'
                className='h-auto w-[50px]'
              >
                <g clipPath='url(#clip0_10923_24838)'>
                  <path
                    fill={isSelected ? "#BE9983" : "#F8F3EF"}
                    d='m26.032-4.093 18.306-.134A10.95 10.95 0 0 1 43.685.12a21.7 21.7 0 0 0-1.973 6.547c.12 1.053 3.426 13.733 3.426 13.733s3.147 11.72 3.147 13.573c0 1.854 3.56 45.56 3.56 45.56l2.373 19.894 1.454 10.666a4.811 4.811 0 0 1-3.707 1.067l-.147 2.467a6.67 6.67 0 0 1-3.853.493c-2.52-.293-4.253-.453-4.253-.453l.346.746a13.5 13.5 0 0 1-5.973 2.427 51 51 0 0 1-8.787-.64 4.5 4.5 0 0 0-2.226-.547 33 33 0 0 1-5.134 1.24 12.8 12.8 0 0 1-4.16-1.04v-.893a20 20 0 0 1-4 0c-1.533-.253-5.426-1.333-5.426-1.333s4.04-20.294 4.533-24.147 2.373-17.04 2.373-18.227c0-1.186 2.667-25.92 2.667-25.92s1.08-9.333 1.333-10.426c.254-1.094 2.414-11.654 2.667-12.294s.587-3.16.587-3.16l8.68 5.134q.383.966.88 1.88c.253.293 3.253 2.906 3.253 2.906a14.5 14.5 0 0 0 2.133-2.56l1.574-3.306s1.586 2.026 1.88 1.92c.293-.107.946-.747.64-1.134l-2.76-3.506q-1.217-.316-2.467-.454a10.3 10.3 0 0 1-3.067-.293c-.493-.293-5.866-3.307-7.506-5.427l-1.334-1.48a3.5 3.5 0 0 0 .094-1.786l-1.707-4.44-1.133-1.774S23.765.84 23.992.493s2.04-4.586 2.04-4.586'
                  />
                  <path
                    fill='#fff'
                    d='M17.937-6.383s8.96.387 8.16 2.76c0 0-4.146 8.227-4.8 9.214-.653.986-1.92 3.306-1.92 3.306a20.5 20.5 0 0 0 2.187 1.84c.587.32 5.333 4.8 6.227 5.72a23.8 23.8 0 0 0 6.426 3.747c1.08.146 3.387-.187 4 .346a12.9 12.9 0 0 1 2.84 3.28c.4.96.467 1.614-.2 1.6l-1.533-2s-2.52 5.134-4 6.107a24.5 24.5 0 0 1-3.68-3.786c-.4-.96-.453-1.254-.947-1.494s-15.146-9.08-15.146-9.08-3.307-2.013-3.64-2.04a2.67 2.67 0 0 1-.894-2.347c.2-.92 5.534-15.493 6.92-17.173'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M43.55 113.697c4.2.267 7.4.894 8.28-.133v-2.453s2.666.786 3.72-.96a977 977 0 0 1-1.56-12.56c-1.694-14.214-3.16-28.534-4.174-42.92-.493-6.774-.773-13.56-1.52-20.32-.746-6.76-5.266-21.427-5.64-22.347a12.25 12.25 0 0 1-.786-6.48c1.053-2.973 2.467-8 2.293-9.133M21.66 4.96c1.893 3.254 2.4 3.854 2.92 7.548-.03.243-.117.476-.253.68'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M24.578 12.68S31.645 12 42.672 12M24.406 11.324a168 168 0 0 1 17.734-.654'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M25.778-3.008s-4.453 8.974-6.226 11.614a.52.52 0 0 0 .12.72 38 38 0 0 1 5.56 4.773 29.2 29.2 0 0 0 7.773 5.826 3 3 0 0 0 1.16.28q2.012.036 4 .347c.528.261.985.645 1.333 1.12.254.347 2.24 2.587 1.947 3.12a.6.6 0 0 1-.56.547.5.5 0 0 1-.307-.067'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M38.887 22.898a20 20 0 0 0 3.253 4.227M17.672-5.945A110 110 0 0 0 11.925 8.08c-.453 1.707-1 3.467-.72 4.134a1.33 1.33 0 0 0 .88.973q.643.247 1.227.613c2.16 1.44 16.96 10.08 17.8 10.774.333.266.547 1.6 1.333 2.266.987.894 3.027 2.667 3.027 2.667'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M39.111 23.352a19.2 19.2 0 0 1-3.693 6.213M33.633 12.18s3.826 6.4 5.093 8.68M41.418 24.367a60.4 60.4 0 0 1 2.453 13.227M17.779 115.016a23.8 23.8 0 0 1-9.334-1.24c.36-1.84.72-3.68 1.067-5.546 3.8-19.067 5.893-38.587 7.893-57.894a172.4 172.4 0 0 1 4.347-27.36c.187-.693.6-2.493.773-3.546'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M24.244 33.455S21.231 47.24 19.791 88.4c-.507 15.92-2.014 27.4-2.014 27.4 4.6 2.44 7.907-.453 9.72 0 5.334 1.187 12.08 2.107 16.547-1.333-1.92-2.987-2.667-12.614-2.893-19.094-.227-6.48-5.734-65.866-5.734-65.866M19.378 48.563s-4.44 34.306-4.44 65.533'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M25.084 21.055c-1.947 22.36-1.6 45.44-1.04 77.493M36.153 34.672s-1.067 28.373-.36 39.92M35.552 20.327a38.5 38.5 0 0 0-2.04-5.054'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_10923_24838'>
                    <path fill='#fff' d='M.887 0h62.227v80H.887z' />
                  </clipPath>
                </defs>
              </svg>
            }
          },
          {
            value: "nonepockets",
            label: "None Pockets",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='64'
                height='80'
                fill='none'
                viewBox='0 0 64 80' className='h-auto w-[50px]'
              >
                <g clipPath='url(#clip0_10923_24961)'>
                  <path
                    fill={isSelected ? "#BE9983" : "#F8F3EF"}
                    d='M59.13 99.205c-1.583-3.857-6.516-18.32-6.516-18.32a46 46 0 0 1-.791-4.648c-.596-4.045-5.6-45.032-5.6-45.032s-1.778-14.524-2.276-16.79S41.28 3.151 41.28 3.151a7.6 7.6 0 0 1-.39-3.058l1.19-9.875-19.626 1.28-.782 7.795h-.17L21.2 4.325s2.57 4.445 2.57 5.44-.89 7.796-1.183 8.89c-.293 1.093-1.68 6.417-1.68 6.417s-.098 5.236.4 6.516 1.849 3.964 1.573 5.742c-.275 1.778-1.28 5.724-1.377 6.418-.098.693-.4 3.155-.791 3.253-.392.098-1.156-.542-1.156-1.084 0-.543-.204-3.458-.204-3.458s-.196 4.649-.587 4.844a1.96 1.96 0 0 1-1.387.391l-5.458 34.57h.045c-.507 1.724-1.129 3.741-1.325 4.15C9.947 87.792.223 108.023.223 108.023s1.573 1.778 2.71 2.142a35.4 35.4 0 0 0 6.57 1.236c1.333-.053 6.862-.053 8 .347s2.87 1.875 3.902 2.071c1.031.195 2.666-.294 4.4-1.085a6.82 6.82 0 0 1 5.129 0c1.635.551 3.457 1.094 3.804.107l-.96-2.231s2.614-1.725 3.351-1.627 2.525-.151 3.21.64c.684.791 1.04 2.027 2.524 2.471a9.98 9.98 0 0 0 6.666 0 46 46 0 0 0 5.974-2.862s7.209-.987 8.097-3.849a17.5 17.5 0 0 1-4.47-6.178'
                  />
                  <path
                    fill='#fff'
                    d='m14.293-9.023.258 8.56s.195 12.773.266 13.688 1.316 15.547 1.316 15.547a10.6 10.6 0 0 1 .133 3.156c-.266.986-.986 3.733-1.057 4.284-.072.551-.72 4.605-.72 4.605-.233.62-.21 1.307.062 1.91.462.987.56 1.156.56 1.156a.98.98 0 0 0 .889.125s.488 1.715.889 1.946c0 0 .168 1.84.888 1.778s.89-.4.96-.889c.072-.489.427-5.03.658-5.066s.134 1.937.134 1.937a6.5 6.5 0 0 0 .195 2.507c.356.622.782 1.12 1.182.676s.56-3.414.56-3.414.17.765.56.436c.391-.33.098-1.351.098-1.85 0-.497.498-3.057.56-3.688a26 26 0 0 0-.951-5.395c-.329-.623-1.289-8.827-1.289-8.827L20.213 12.7l.693-8.098L22.551-8.73z'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M14.402-7.937s.4 14.16.4 15.937v3.938c0 3.156 1.44 17.733 1.44 18.916a10.9 10.9 0 0 1-.525 3.67 8.6 8.6 0 0 0-.604 2.232c-.178.969-.569 3.555-.614 3.813a4.5 4.5 0 0 0-.133 1.573c.133.347.64 2.027 1.076 1.983a1.7 1.7 0 0 0 .702-.222M21.103 4.234s2.365 3.671 2.756 5.636c0 0-1.316 9.636-1.974 11.609a64 64 0 0 0-1.182 4.07M41.984-8.336S40.67.882 41.06 2.43a125 125 0 0 1 4.107 19.83c1.448 11.298 6.275 51.618 6.8 55.556s7.11 25.085 11.813 27.84c-2.213 2.569-5.333 3.556-8.658 3.662-3.413 2.347-8.889 4.809-12.871 2.489-2.231-1.306-.782-2.231-3.147-2.755-2.364-.525-3.555.889-5.12 1.449'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M26.481 25.945s0 38.614.658 45.831 4.338 37.432 7.751 41.369c0 0-.267.889-4.444-.524-4.178-1.413-5.654 1.707-8.41 1.315-2.755-.391-2.48-2.364-6.035-2.364S2.872 111.83.25 108.016c0 0 11.031-20.622 11.813-26.133.783-5.511 5.165-34.453 5.165-34.453M23.945 9.613s2.41 1.395 3.556 1.137c1.146-.257 12.275-2.968 13.849-6.906'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M17.555 41.482s-.889 6.133-.178 6.222 1.405-.356 1.405-.791q.13-2.51.524-4.996s.17-.524.48-.08l-.267 3.556c.267 2.24 1.387 1.484 1.387 1.484 0-1.315 1.05-4.995 1.707-7.75.658-2.756-.889-5.636-1.298-7.343a57 57 0 0 1-.738-7.529c-.266-3.68-.133-10.115-.266-11.298-.134-1.182.266-2.23.266-3.804s1.707-15.52 1.707-15.52'
                  />
                  <path
                    stroke='#80583F'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='0.65'
                    d='M17.12 46.125c-.613.089-.889-1.485-.889-1.485q-.135-2.102 0-4.204c-.266-.436-.524 0-.524 0v1.697s.169.89.462.72M22.115 41.008a11 11 0 0 0 0 2.329c.169.4-.16.657-.56.533M20.07 39.773a.82.82 0 0 0 .107.658M17.716 39.805a.75.75 0 0 0 .054.586M16 38.648c0 .19.03.38.089.56M29.902 42.664s3.414 48.329 2.89 53.058c-.525 4.729-.792 8.667-.792 8.667M40.145 8.297c1.404 4.026 4.853 11.795 7.235 32.48'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_10923_24961'>
                    <path fill='#fff' d='M.89 0h62.223v80H.89z' />
                  </clipPath>
                </defs>
              </svg>
          
            }
          },
        ],
      },
      hasBackOption && {
        value: "backDetail",
        name: "backDetail",
        label: "Back Detail",
        options: [
          {
            value: "laceup",
            label: "Lace-up",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='51'
                height='80'
                fill='none'
                viewBox='0 0 51 80'
                className='h-auto w-10'
              >
                <path
                  fill='#fff'
                  d='M37.637 11.465C32.304 10.932 30.704.398 30.704.398H20.037s-1.6 10.534-6.933 11.067-15.067.533-11.867 8.933S13.37 49.465 13.104 52.132C12.837 54.798 1.77 65.865 2.837 79.598h45.467c1.066-13.733-10-24.8-10.267-27.466s8.667-23.334 11.867-31.734-6.934-8.4-12.267-8.933'
                />
                <path
                  fill={isSelected ? "#BE9983" : "#F8F3EF"}
                  d='m45.502 31.867-6.8 17.333-1.2 4.134a71 71 0 0 1 6.8 9.733 9.42 9.42 0 0 1-.267 10.533l-18.533 3.2-18.4-3.2a9.42 9.42 0 0 1-.267-10.533c2-3.426 4.28-6.68 6.8-9.733l-1.2-4.134-6.4-16.533S21.635 35.6 26.97 35.6a50.5 50.5 0 0 0 18.533-3.733'
                />
                <path
                  fill={isSelected ? "#BE9983" : "#F8F3EF"}
                  d='M11.768 47.469a14.9 14.9 0 0 1 1.2 4.666C12.701 54.802 1.635 65.87 2.701 79.602h45.6c1.067-13.733-10-24.8-10.266-27.467.2-1.6.6-3.173 1.2-4.666-15.867 7.733-27.467 0-27.467 0M21.369 35.465A92.5 92.5 0 0 1 5.902 32.53z'
                />
                <path
                  fill='#80583F'
                  d='M21.367 35.733a81.7 81.7 0 0 1-15.6-2.933c-.134 0-.267-.267-.267-.4 0-.134.267-.267.4-.267a100 100 0 0 0 15.467 2.933c.133 0 .266.133.266.4s0 .267-.266.267M29.767 35.863a.29.29 0 0 1-.267-.266c0-.134.133-.4.267-.4a45.5 45.5 0 0 0 15.466-3.6c.147-.08.32-.014.4.133s.014.32-.133.4c-5.733 2.8-12.933 3.467-15.733 3.733'
                />
                <path
                  fill='#80583F'
                  d='M48.301 80h-45.6a.29.29 0 0 1-.267-.267C1.634 69.6 7.234 61.2 10.568 56c1.2-1.867 2.133-3.2 2.133-3.867C12.834 50.4 8.434 39.6 4.968 30.8c-1.6-4-3.067-7.733-4.134-10.267a6.23 6.23 0 0 1 .134-5.6C2.834 12 8.034 11.6 11.768 11.2c.533 0 1.066-.133 1.466-.133C18.168 10.533 19.768.4 19.768.267s.266-.267.4-.267h10.666c.147.013.254.12.267.267 0 .133 1.6 10.266 6.533 10.8.534 0 .934.133 1.467.133 3.867.267 9.067.8 10.933 3.733a6.23 6.23 0 0 1 .134 5.6c-.934 2.534-2.534 6.4-4.134 10.267-3.466 8.667-7.866 19.467-7.733 21.333A11.3 11.3 0 0 0 40.434 56c3.334 5.067 8.934 13.6 8.134 23.6 0 .267-.134.4-.267.4m-45.2-.667h44.933c.667-9.733-4.8-18-8-22.933-1.333-2-2.266-3.333-2.266-4.267-.267-1.733 3.066-10 7.733-21.466 1.6-4 3.067-7.734 4.133-10.267a5.57 5.57 0 0 0 0-5.067c-1.733-2.666-6.666-3.066-10.4-3.333-.533 0-1.066-.133-1.466-.133C32.7 11.333 30.968 2.533 30.7.8h-10c-.267 1.733-2.133 10.667-7.067 11.067-.533 0-.933.133-1.466.133-4 .267-8.934.667-10.667 3.333-.8 1.2-.8 2.934 0 5.067.933 2.533 2.4 6.267 4 10.267 4.667 11.466 8 19.866 7.733 21.6a16.8 16.8 0 0 1-2.266 4.266C7.9 61.333 2.434 69.6 3.1 79.333'
                />
                <path
                  fill={isSelected ? "#BE9983" : "#F8F3EF"}
                  d='m31.101 35.469-5.466 18.84-5.467-18.8a131 131 0 0 0 10.933-.04'
                />
                <path
                  fill='#80583F'
                  d='M25.636 54.663a.29.29 0 0 1-.267-.267l-5.467-18.934v-.266c.134-.133.134-.133.267-.133q5.4.3 10.8 0c.133 0 .267 0 .267.133s.133.133 0 .267l-5.467 18.84c.133.226 0 .36-.133.36m-4.934-18.934 4.934 17.334 4.933-17.334a61 61 0 0 1-9.867 0'
                />
                <path
                  fill='#80583F'
                  d='m30.701 38.802-10.266-2.534c-.134 0-.267-.266-.267-.4 0-.133.267-.266.4-.266l10.267 2.533c.133 0 .266.267.266.4s-.266.267-.4.267'
                />
                <path
                  fill='#80583F'
                  d='M20.567 38.802a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.266 0 .267 0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='M30.701 41.333 20.435 38.8c-.134 0-.267-.267-.267-.4 0-.134.267-.267.4-.267l10.267 2.533c.133 0 .266.267.266.4s-.266.267-.4.267'
                />
                <path
                  fill='#80583F'
                  d='M20.567 41.333a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.267 0 .266 0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='m30.701 43.872-10.266-2.533c-.134 0-.267-.267-.267-.4 0-.134.267-.267.4-.267l10.267 2.533c.133 0 .266.267.266.4 0 .134-.266.267-.4.267'
                />
                <path
                  fill='#80583F'
                  d='M20.567 43.872a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.267 0 .266 0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='M30.701 46.403 20.435 43.87c-.134 0-.267-.267-.267-.4s.267-.267.4-.267l10.267 2.533c.133 0 .266.267.266.4 0 .134-.266.267-.4.267'
                />
                <path
                  fill='#80583F'
                  d='M20.567 46.403a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.267s0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='M30.701 48.973 20.435 46.44c-.134 0-.267-.267-.267-.4s.267-.267.4-.267l10.267 2.534c.133 0 .266.266.266.4 0 .133-.266.266-.4.266'
                />
                <path
                  fill='#80583F'
                  d='M20.567 48.973a.29.29 0 0 1-.266-.266c0-.134 0-.4.266-.4l10.267-2.534c.134 0 .4 0 .4.267s0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='M30.701 51.465 20.435 48.97c-.134 0-.267-.266-.267-.4 0-.133.267-.266.4-.266l10.267 2.533c.133 0 .266.267.266.4s-.266.227-.4.227'
                />
                <path
                  fill='#80583F'
                  d='M20.567 51.466a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.266 0 .267 0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='M30.701 54.005 20.435 51.47c-.134 0-.267-.266-.267-.4 0-.133.267-.266.4-.266l10.267 2.533c.133 0 .266.267.266.4s-.266.267-.4.267'
                />
                <path
                  fill='#80583F'
                  d='M20.567 54.005a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.266 0 .267 0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='m30.701 56.536-10.266-2.533c-.134 0-.267-.267-.267-.4 0-.134.267-.267.4-.267l10.267 2.667c.133 0 .266.266.266.4a.5.5 0 0 1-.4.133'
                />
                <path
                  fill='#80583F'
                  d='M20.567 56.536a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.267 0 .266 0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='m30.701 59.067-10.266-2.533c-.134 0-.267-.267-.267-.4s.267-.267.4-.267l10.267 2.534c.133 0 .266.266.266.4 0 .133-.266.266-.4.266'
                />
                <path
                  fill='#80583F'
                  d='M20.567 59.067a.29.29 0 0 1-.266-.267c0-.133 0-.4.266-.4l10.267-2.533c.134 0 .4 0 .4.267s0 .4-.267.4z'
                />
                <path
                  fill='#80583F'
                  d='m30.701 61.731-10.266-2.533c-.134 0-.267-.267-.267-.4s.267-.267.4-.267l10.267 2.534c.133 0 .266.266.266.4 0 .133-.266.266-.4.266'
                />
                <path
                  fill='#80583F'
                  d='M20.567 61.731a.29.29 0 0 1-.266-.266c0-.134 0-.4.266-.4l10.267-2.534c.134 0 .4 0 .4.267s0 .4-.267.4zM20.17 35.73a.46.46 0 0 1-.267-.133L9.77 12.264c-.133-.133 0-.267.133-.4a.27.27 0 0 1 .36.04c.027.027.04.053.04.093l10.134 23.334c.133.133.133.4-.267.4M31.1 35.868c-.266-.134-.4-.267-.266-.4L40.7 12c.133-.133.267-.267.4-.133.134.133.267.266.134.4L31.367 35.64c-.134.093-.133.227-.267.227'
                />
              </svg>
            }
          },
          {
            value: "zipper",
            label: "Zipper",
            renderIcon: (isSelected:boolean) => {
              return <svg
                xmlns='http://www.w3.org/2000/svg'
                width='51'
                height='80'
                fill='none'
                viewBox='0 0 51 80'
                className='h-auto w-10'
              >
                <path
                  fill='#fff'
                  d='M37.633 11.465C32.3 10.932 30.7.398 30.7.398H20.033s-1.6 10.534-6.933 11.067-15.067.533-11.867 8.933S13.366 49.465 13.1 52.132c-.267 2.666-11.334 13.733-10.267 27.466H48.3c1.067-13.733-10-24.8-10.267-27.466S46.7 28.798 49.9 20.398s-6.933-8.4-12.267-8.933'
                />
                <path
                  fill={isSelected ? "#BE9983" : "#F8F3EF"}
                  d='m45.502 31.867-6.8 17.333-1.2 4.134a71 71 0 0 1 6.8 9.733 9.42 9.42 0 0 1-.267 10.533l-18.533 3.2-18.4-3.2a9.42 9.42 0 0 1-.267-10.533c2-3.426 4.28-6.68 6.8-9.733l-1.2-4.134-6.4-16.573a73.5 73.5 0 0 0 19.467 2.933 64.8 64.8 0 0 0 20-3.693'
                />
                <path
                  fill='#80583F'
                  d='M25.502 35.87a74.9 74.9 0 0 1-19.2-2.8c-.134 0-.267-.266-.267-.4 0-.133.267-.266.4-.266a74.4 74.4 0 0 0 19.067 2.8 62.5 62.5 0 0 0 19.6-3.467c.147-.08.32-.013.4.134.08.146.013.32-.134.4a58 58 0 0 1-19.866 3.6'
                />
                <path
                  fill={isSelected ? "#BE9983" : "#F8F3EF"}
                  d='M11.768 47.469a14.9 14.9 0 0 1 1.2 4.666C12.701 54.802 1.635 65.87 2.701 79.602h45.6c1.067-13.733-10-24.8-10.266-27.467.2-1.6.6-3.173 1.2-4.666-15.867 7.733-27.467 0-27.467 0'
                />
                <path
                  fill='#80583F'
                  d='M48.301 80h-45.6a.29.29 0 0 1-.267-.267c-.8-10 4.8-18.533 8.134-23.733 1.2-1.867 2.133-3.2 2.133-3.867C12.834 50.4 8.434 39.6 4.968 30.8c-1.6-4-3.067-7.733-4.134-10.267a6.23 6.23 0 0 1 .134-5.6C2.834 12 8.034 11.6 11.768 11.2c.533 0 1.066-.133 1.466-.133C18.168 10.533 19.768.4 19.768.267s.266-.267.4-.267h10.666c.147.013.254.12.267.267 0 .133 1.6 10.266 6.533 10.8.4 0 .934.133 1.467.133 3.867.267 9.067.8 10.933 3.733a6.23 6.23 0 0 1 .134 5.6c-.934 2.534-2.534 6.4-4.134 10.267-3.466 8.667-7.866 19.467-7.733 21.333A11.3 11.3 0 0 0 40.434 56c3.334 5.067 8.934 13.6 8.134 23.6 0 .267-.134.4-.267.4m-45.2-.667h44.853c.667-9.733-4.8-18-8-22.933-1.333-2-2.266-3.333-2.266-4.267-.134-1.733 3.2-10.133 7.733-21.6 1.6-4 3.067-7.733 4.133-10.266a5.57 5.57 0 0 0 0-5.067c-1.733-2.667-6.666-3.067-10.4-3.333-.533 0-1.066-.134-1.466-.134C32.62 11.2 30.888 2.4 30.62.667h-10c-.4 1.733-2.133 10.666-7.2 11.066-.533 0-.933.134-1.467.134-3.733.4-8.666.8-10.4 3.466-.8 1.2-.8 2.934 0 5.067.934 2.533 2.4 6.267 4.134 10.267 4.666 11.466 8 19.866 7.733 21.6a16.8 16.8 0 0 1-2.267 4.266c-3.2 4.8-8.72 13.067-8.053 22.76z'
                />
                <path
                  fill='#80583F'
                  d='M25.501 54.67a.29.29 0 0 1-.267-.267V35.47a.267.267 0 0 1 .533 0v18.8c0 .266-.133.4-.266.4'
                />
                <path fill='#80583F' d='m25.902 38.002-.8.4V35.87l.8-.4z' />
                <path
                  fill='#80583F'
                  d='M25.099 38.67h-.134c-.133 0-.133-.134-.133-.267v-2.4a.46.46 0 0 1 .133-.267l.8-.4h.267c.133 0 .133.133.133.267v2.36a.46.46 0 0 1-.133.266l-.933.4zm.266-2.534v1.733l.134-.133v-1.733z'
                />
              </svg>
            }
          },
        ],
      },
    ].filter(Boolean),
    [hasLengthOption, hasPocketsOption, hasBackOption]
  )

  if (!isCustomizedSize) {
    return null
  }

  if (!hasPocketsOption && !hasLengthOption && !hasBackOption) {
    return null
  }

  return (
    <div className='border-b-1 border-t-1 border-E7DED5 lg_px-0 mt-5 border-solid px-[15px]'>
      <button
        className='lg_pr-[25px] flex w-full items-center justify-between  py-5 text-base uppercase leading-[22px]'
        type='button'
        onClick={() => {
          setExpanded((x) => !x)
        }}
      >
        <span>Change Style</span>
        <span
          className={clsx(
            " relative h-3 w-3 ",
            'before_content-[""] after_content-[""]',
            "before_h-0.5 before_w-full after_h-0.5 after_w-full",
            "before_bg-80583F",
            "before_absolute before_left-1/2 before_top-1/2 before_-translate-x-1/2 before_-translate-y-1/2",
            "after_absolute after_left-1/2 after_top-1/2 after_-translate-x-1/2 after_-translate-y-1/2",
            "after_rotate-90",
            expanded ? "after_bg-transparent" : "after_bg-80583F"
          )}
        />
      </button>
      <Tabs
        defaultValue={(tabs as tabsType)[0]?.value}
        className={clsx("w-full pb-14", !expanded && "hidden")}
      >
        <TabsList className='flex w-full justify-center gap-x-10'>
          {(tabs as tabsType).map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className='text-8B857D data-[state="active"]_text-#403732 w-fit justify-center border-none px-0 text-sm font-normal leading-5 underline'
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {(tabs as tabsType).map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className='mt-1.5'>
            <FormField
              control={form.control}
              name={tab.name}
              render={({
                field 
              }) => (
                <FormItem>
                  <FormControl>
                    <RadioGroup
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                      className='lg_gap-x-5 flex justify-center gap-x-3 space-y-0'
                    >
                      {tab.options.map((item, index) => (
                        <ChangeStyleRadioItem
                          key={index}
                          item={item}
                          name={tab.name}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                  <FormMessage id={tab.name} />
                </FormItem>
              )}
            />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  )
}

type ChangeStyleType = {
  name?: string
  value: string
  label: string
  renderIcon:(isSelected:boolean) => ReactNode;
}

const ChangeStyleRadioItem = ({
  item,
  name,
}: {
  item: ChangeStyleType
  name: string
}) => {
  const {
    watch 
  } = useFormContext()

  const selectedValue = watch(name)

  const isSelected = selectedValue === item.value

  return (
    <FormItem className='flex items-center space-y-0'>
      <FormControl>
        <RadioGroupItem value={item.value} className='peer sr-only' />
      </FormControl>
      <FormLabel
        className={cn(
          "  peer-data-[state=checked]_border-primary text-8B857D  [&:has([data-state=checked])]_border-primary  relative flex cursor-pointer items-center justify-center bg-white ",
          "border-1 h-[86px] w-[56px] border-solid border-transparent",
          !isSelected && "text-8B857D",
        )}
      >
        {item.renderIcon?.(isSelected)}
        <div className='absolute bottom-[-20px] whitespace-nowrap text-center text-[13px]'>
          {item.label}
        </div>
      </FormLabel>
    </FormItem>
  )
}
